import cx from 'classix'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useAfiUThemes from '@components/hooks/useAfiUThemes'

import i18n from '@src/config/i18n'
import locales from '@src/config/locales'

import NavButtonLink from '../NavButtonLink'
import { getTrainingTabs, TrainingTab } from '../constants/trainings'
import SectionsDescriptionGrid from '../content/SectionsDescriptionGrid'
import SectionsLinksGrid from '../content/SectionsLinksGrid'
import MegaMenu from '../menu/MegaMenu'
import MegaMenuContent from '../menu/MegaMenuContent'

type Props = {
  open: boolean
}

export default function TrainingsTabMenu({ open }: Props) {
  const { t } = useTranslation('revamp')
  const afiUThemes = useAfiUThemes()
  const [selectedTab, setSelectedTab] = useState<TrainingTab | undefined>(TrainingTab.TOPIC)

  const locale = i18n.language

  const trainingTabs = getTrainingTabs(t, locale, afiUThemes)

  const tabConfig = selectedTab === undefined ? undefined : trainingTabs[selectedTab]

  useEffect(() => {
    if (open) {
      setSelectedTab(TrainingTab.TOPIC)
    }
  }, [open])

  return (
    <MegaMenu open={open} className='flex flex-row items-start text-white'>
      <section className='flex flex-col items-start w-2/5'>
        <span className='mb-6 leading-mid'>{t('formationsSortBy')}</span>
        <div className='flex flex-col items-start gap-8 text-r-3xl font-bold leading-none'>
          {trainingTabs.map((tab) => (
            <button
              key={`trainings_tab_${tab.name}`}
              className={cx(
                'text-left font-bold underline-thick',
                selectedTab === tab.key ? 'opacity-100 underline' : 'opacity-80'
              )}
              onClick={() => setSelectedTab(tab.key)}
              onMouseEnter={() => setSelectedTab(tab.key)}
            >
              {tab.name}
            </button>
          ))}
          <a
            className='underline-thick hover:underline opacity-80 hover:opacity-100'
            href={locales[locale].catalogGuaranteedSessionsPath}
            onMouseEnter={() => setSelectedTab(undefined)}
          >
            {t('guaranteedSessions')}
          </a>
        </div>
        <NavButtonLink
          className='mt-24 text-r-xl'
          link={locales[locale].catalogResetFiltersPath}
          text={t('viewAllCourses')}
        />
      </section>
      <MegaMenuContent>
        {tabConfig &&
          (tabConfig.type === 'links' ? (
            <SectionsLinksGrid sections={tabConfig.sections} />
          ) : (
            <SectionsDescriptionGrid sections={tabConfig.sections} />
          ))}
      </MegaMenuContent>
    </MegaMenu>
  )
}
